module.exports = __webpack_public_path__ + "img/b3.c638f67b.png";